import { Loading } from '@cibo/profile'
import { useProgramEngagements } from '@cibo/programs'
import { DataGridPro } from '@cibo/ui'
import { GridColDef } from '@mui/x-data-grid-pro'
import { useMemo } from 'react'
import { useEngagementsColumns } from './useEngagementsColumns'

type PaginatedEngagementsTableProps = {
  onRowClick(): void
  programId: string
}

export const PaginatedEngagementsTable = ({
  programId,
  onRowClick,
}: PaginatedEngagementsTableProps) => {
  const { owner, metadata, applicationStatus: status } = useEngagementsColumns()

  const columns = useMemo(() => [status, owner, metadata] as GridColDef[], [])

  const engagements = useProgramEngagements({
    programId: [programId],
    hasUncommittedFields: true,
  })

  if (!engagements.isFetched) {
    return <Loading />
  }

  return (
    <DataGridPro
      columns={columns}
      headerHeight={0}
      rows={engagements.data?.items || []}
      loading={engagements.isLoading}
      onRowClick={onRowClick}
      disableSelectionOnClick
      autoHeight
    />
  )
}
